<script setup lang="ts">
import { useLocalePath } from '#i18n'
import { useRuntimeConfig } from '#app'
import { useCountryConfig } from '~/composables/useCountryConfig'

const { environment } = useRuntimeConfig().public
const localePath = useLocalePath()
const { appBarLogo } = useCountryConfig()
</script>

<template>
  <NuxtLink :to="localePath('/')">
    <v-badge
      v-if="environment !== 'prod'"
      :content="environment"
      :color="environment === 'staging' ? 'heiland-light-blue' : 'heiland-purple'"
    >
      <nuxt-picture
        :src="appBarLogo"
        width="138"
        height="30"
        alt="Logo"
      />
    </v-badge>
    <nuxt-picture
      v-else
      :src="appBarLogo"
      width="138"
      height="30"
      alt="Logo"
    />
  </NuxtLink>
</template>
